<script>
    // Renedrer for ohlcbar + volume (optional)
    // It can be used as the main chart or an indicator

    import XCandle from './primitives/xcandle.js'
    import XVolbar from './primitives/xvolbar.js'
    import Price from './primitives/price.js'
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'XCandles',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'Mano',
                    version: '1.0.0',
                    desc: 'Candlestick Chart',
                    preset: {
                        name: 'XCandles',
                        side: 'onchart',
                        settings: {
                            showVolume: true,
                            priceLine: true,
                            upBarColor: 'rgb(38, 166, 154)',
                            downBarColor: 'rgb(239, 83, 80)',
                            barWidth: 1,
                            lineWidth: 1
                        }
                    }
                }
            },
            init() {
                this.price = new Price(this)
            },
            draw(ctx) {

                //console.log("XCandle.draw() called. this.$props.data.length = " + this.$props.data.length)

                // render as main chart:
                if (this.$props.sub === this.$props.data) {
                    var cnv = {
                        ohlcbars: this.$props.layout.candles,
                        volume: this.$props.layout.volume,
                    }
                    // Else, as offchart / onchart indicator:
                } else {
                    cnv = layout_cnv(this)
                }

                if (this.show_volume) {
                    for (let i = 0; i < cnv.volume.length; i++) {
                        let volumeData = cnv.volume[i]
                        let barData = cnv.ohlcbars[i]
                        new XVolbar(this, ctx, volumeData, barData)
                    }
                }

                for (var barData of cnv.ohlcbars) {
                    new XCandle(this, ctx, barData)
                }

                if (this.price_line) this.price.draw(ctx)
            },
            use_for() { return ['XCandles'] },

            // When added as offchart overlay
            y_range() {
                return [
                    Math.max(...this.$props.sub.map(x => x[2])),
                    Math.min(...this.$props.sub.map(x => x[3]))
                ]
            }
        },

        // Define internal setting & constants here
        computed: {
            sett() {
                return this.$props.settings
            },
            show_volume() {
                return 'showVolume' in this.sett ?
                    this.sett.showVolume : true
            },
            price_line() {
                return 'priceLine' in this.sett ?
                    this.sett.priceLine : true
            },
            upVolBarColor() {
                return this.sett.upBarColor || "#23a77655"
            },
            downVolBarColor() {
                return this.sett.downBarColor || "#e5415055"
            },
            volBarWidth() {
                return this.sett.barWidth || 2
            },
            upBarColor() {
                return this.sett.upBarColor || "rgb(38, 166, 154)"
            },
            downBarColor() {
                return this.sett.downBarColor || "rgb(239, 83, 80)"
            },
            blackBarColor() {
                return this.sett.blackBarColor || "#000000"
            },
            barWidth() {
                return this.sett.barWidth || 1
            },
            hlcOnly() {
                return this.sett.hlcOnly || false
            },
            lineWidth() {
                return this.sett.lineWidth || 1
            }
        },
        data() {
            return { price: {} }
        }

    }
</script>
